import React, { FC } from 'react'
import AnswerTileContainer from '@components/organisms/AnswerTileContainer'
import { PollProps } from './types'

const Poll: FC<PollProps> = (props) => {
  return <AnswerTileContainer {...props} data-testid="poll" />
}

export default Poll
